import React, { useState } from 'react';
import { peicarLogoSVG } from '../../Assets/Images';
import { BsSearch } from 'react-icons/bs';
import { RxHamburgerMenu } from 'react-icons/rx';
import { scrollToBottom, scrollToElement } from '../../Views/Landing/functions';
import { SideMenu } from '../Header/SideMenu/SideMenu';
import { genericHeaderCSS } from './GenericHeader.css';
import { useNavigate } from 'react-router-dom';


function GenericHeader(props) {
    const [showSidebar, setShowSidebar] = useState(false);
    const navigateTo = useNavigate();

    function goHome(section){
        navigateTo("/" + section)
    }

    return (
        <div css={genericHeaderCSS()}>
            <div className="Container">
                <div className="Left GridItem">
                    <img src={peicarLogoSVG} onClick={()=>goHome("home")} />
                    <span>La llave a tu movilidad</span>
                </div>

                {/* <div className="Center GridItem">
                    <div className="SearchContainer">
                        <input type="text" className='SearchInput' placeholder='Buscar' />
                        <BsSearch className='Icon' />
                    </div>
                </div> */}

                <div className="Right GridItem">
                    <div className="Nav">
                        <span onClick={()=>goHome("home")}>
                            Home
                        </span>

                        <span onClick={()=>goHome("producto")}>
                            Producto
                        </span>

                        <span onClick={()=>goHome("conoce")}>
                            Con&oacute;cenos
                        </span>

                        <span onClick={()=>goHome("proceso")}>
                            Proceso
                        </span>

                        <span onClick={()=>goHome("hablemos")}>
                            Hablemos
                        </span>
                    </div>

                    <div className="SideMenuContainer">
                        <RxHamburgerMenu 
                            className='Icon'
                            onClick={() => setShowSidebar(true)} 
                        />
                        <SideMenu
                            visible={showSidebar}
                            setVisible={setShowSidebar}
                        >

                            <nav className='MobileNav'>
                                <span onClick={()=>goHome("producto")}>
                                    Producto
                                </span>

                                <span onClick={()=>goHome("conoce")}>
                                    Con&oacute;cenos
                                </span>

                                <span onClick={()=>goHome("proceso")}>
                                    Proceso
                                </span>

                                <span onClick={()=>goHome("hablemos")}>
                                    Hablemos
                                </span>
                            </nav>
                        </SideMenu>
                    </div>
                </div>
            </div>
        </div>
    );
}

export {GenericHeader};